import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { NUMBER_SIZE } from '../../../../constants/size'
import { FileIconPreview } from '../../../FileIcon'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import { useWidgetContentFileItemHandlers } from '../WidgetContentFiles.hooks'
import { WidgetContentFilesDownloadButton } from '../WidgetContentFilesDownloadButton'

import * as styles from './WidgetContentFilesDocumentsListItem.module.css'

function WidgetContentFilesDocumentsListItem({
  className = styles.WidgetContentFilesDocumentsListItem,
  file,
  scope,
  onClick,
  onSuccessDownloadFile,
}) {
  const { t } = useTranslation()

  const { handleClick, handleClickDownloadFile, loading } =
    useWidgetContentFileItemHandlers({
      file,
      scope,
      onClick,
      onSuccessDownloadFile,
    })

  const commonStylesMods = {
    [styles.disabled]: loading,
    [styles.loading]: loading,
  }

  const filename = file.filename || file.name

  return (
    <div
      className={classNames(className, commonStylesMods)}
      onClick={handleClick}
    >
      <div className={styles.infoContainer}>
        <FileIconPreview
          className={classNames(styles.docIcon, commonStylesMods)}
          file={file}
          size={NUMBER_SIZE.size32}
        />
        <FloatingTooltip
          content={
            <FloatingTooltipContentText
              additionalText={t('FilePreview.TooltipClickToOpenTextKey')}
              text={filename}
            />
          }
        >
          <span className={classNames(styles.fileName, commonStylesMods)}>
            {filename}
          </span>
        </FloatingTooltip>
      </div>
      <WidgetContentFilesDownloadButton
        className={styles.downloadButton}
        loading={loading}
        onClick={handleClickDownloadFile}
      />
    </div>
  )
}

export default WidgetContentFilesDocumentsListItem
